module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "title-area",
    class: {
      'is-dashed': _vm.dashed
    }
  }, [_c('div', {
    staticClass: "titles "
  }, [_c('span', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.hint))])]), _vm._v(" "), _c('div', {
    staticClass: "contents clearfix",
    style: ({
      'margin-left': _vm.marginLeft + 'px',
      'padding-right': _vm.paddingRight + 'px'
    })
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-87a90366"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/publish_apply/module/title_area.vue
// module id = 1275
// module chunks = 1